<template>
  <div>
    <!-- <TournamentsListPinned v-if="!isMy && !special" /> -->

    <!--    TEMPORARY HARDCODED BANNER WITH ADVERTISEMENT OF MARKETPLACE-->
    <!-- <a
      v-if="heraShopLink"
      :href="heraShopLink"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img :src="banner" alt="Advertisement" class="w-100 mb-5" />
    </a> -->
    <!--    TEMPORARY HARDCODED BANNER WITH ADVERTISEMENT OF MARKETPLACE-->

    <PlayerHeraList
      :data-source="getTournamentsReplaced"
      :filters="filters"
      :dummy-props="{
        iconName: 'empty-competitions',
        headerText: $t(
          '_web_competitions_tournaments-list-empty',
          'There are no tournaments at the moment'
        ),
        text: $t(
          '_web_competitions_tournaments-list-empty-subheader',
          'Check the filters or come back later. Hope you find what you are looking for'
        ),
      }"
      filters-on-top
    >
      <TextBlock
        slot="filterBefore"
        class="mb-4"
        tag="h1"
        :size="1.5"
        :line-height="1.5"
      >
        {{
          $t(
            '_web_competitions_tournaments-list-subheader',
            'Current and upcoming tournaments'
          )
        }}
      </TextBlock>
      <TournamentCard
        slot-scope="{ item: tournament }"
        v-bind="{ tournament }"
        class="h-100"
        :is-tournament-page="true"
      />
    </PlayerHeraList>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PlayerHeraList from '@/components/organisms/List';
import TournamentCard from '@/components/common/TournamentCard';
import TextBlock from '@/components/atoms/TextBlock';
import { prop } from '@/utils/factories';

import ArBanner from '@/assets/images/advertisement-banners/banner_ar.png';
import EnBanner from '@/assets/images/advertisement-banners/banner_eng.png';

export default {
  name: 'PlayerTournamentsList',
  components: {
    TextBlock,
    PlayerHeraList,
    TournamentCard,
  },
  props: {
    isMy: prop(Boolean),
    special: prop(Boolean),
  },
  computed: {
    ...mapState('my', ['accountId']),
    ...mapGetters(['isRTL']),
    banner() {
      return this.isRTL ? ArBanner : EnBanner;
    },
    filters({ $t }) {
      return [
        {
          type: 'GamesAutocomplete',
          label: $t('_web_competitions_tournaments-game-label', 'Games'),
          saveAs: 'game',
          saveOn: 'input',
          class: {
            'col-12 col-md-3': true,
          },
        },
        {
          type: 'PlatformsMultiselect',
          label: $t(
            '_web_competitions_tournaments-platforms-label',
            'Platforms'
          ),
          saveAs: 'platform',
          saveOn: 'input',
          class: {
            'col-12 col-md-2': true,
          },
        },
        {
          type: 'Status',
          label: $t(
            '_web_competitions_tournaments-list-status-filter-label',
            'Status'
          ),
          saveAs: 'status',
          saveOn: 'input',
          props: {
            value: this.$route.params.closed
              ? [{ id: 'closed', name: 'closed' }]
              : [],
            allPlaceholder: $t(
              '_web_competitions_tournaments-list-all-statuses',
              'All statuses'
            ),
          },
          class: {
            'col-12 col-md-2': true,
          },
        },
        {
          type: 'SortBy',
          label: $t('_web_competitions_tournaments-list-sort-label', 'Sort by'),
          saveAs: 'order_by',
          saveOn: 'input',
          props: {},
          class: {
            'col-12 col-md-2': true,
          },
        },
        {
          type: 'Search',
          label: $t(
            '_web_competitions_tournaments-list-search-filter-label',
            ''
          ),
          saveAs: 'name',
          saveOn: 'input',
          props: {
            icon: 'search',
            size: 16,
            placeholder: $t(
              '_web_competitions_tournaments-list-search-filter-placeholder',
              'Search tournaments'
            ),
          },
          class: {
            'mt-4': true,
            'col-12 col-md-3 h-ml-auto': true,
          },
        },
      ];
    },
    heraShopLink() {
      const region = JSON.parse(localStorage.getItem('region'));
      const locale = JSON.parse(localStorage.getItem('locale'));
      return region.feature_flags.marketplace_url
        ? `${region.feature_flags.marketplace_url}${locale.key}-sa/`
        : null;
    },
  },
  methods: {
    ...mapActions(['getTournaments']),
    getTournamentsReplaced(event) {
      return this.isMy
        ? this.getTournaments({ ...event, player: this.accountId })
        : this.special
        ? this.getTournaments({ ...event, is_special_event: true })
        : this.getTournaments(event);
    },
  },
};
</script>
